// This class extends the intersection observer to return the "most visible" element

export default class VisibilityController extends Classy {
  constructor() {
    super();
    // The active / most visible block
    this.active = null;
    // The current score of visibility
    this.score = 0;
    // Start by creating 50 observers
    this.observers = [];
    // The blocks being observed
    this.blocks = [];
    for (let i = 0; i < 50; i++) {
      // Create a new observer
      const Observer = new IntersectionObserver(entries => {
        // Reset the score
        this.score = 0;
        // grab the previous active block
        let prevActive = this.active;

        // Loop through all the entries
        entries.forEach(entry => {
          // Set the entry's intersection score to 0
          entry.target.intersectionScore = 0;
          // If the entry is is view
          if (entry.isIntersecting) entry.target.intersectionScore = i;
        });

        // Loop through all the blocks
        this.blocks.forEach(block => {
          // if the block's interesection score is greater than highestScore, set it as the active block
          if (block.intersectionScore > this.score) {
            this.score = block.intersectionScore;
            this.active = block;
          }
        });

        // If active == prevActive, return
        if (this.active == prevActive) return;

        // Call the change method
        this.change();
      }, {
        rootMargin: `-${i}% 0px -${i}% 0px`
      });

      // Add the observer to the observers array
      this.observers.push(Observer);
    }
  }
  observe(element) {
    // Add the element to the blocks array
    this.blocks.push(element);
    // Observe the element with all the observers
    this.observers.forEach(Observer => Observer.observe(element));
  }
  change() {
    this.callback('change', this.active);
  }
}